export const roomId = {
  type: "number",
  minimum: 0,
  maximum: Number.MAX_SAFE_INTEGER
};
export const nullableRoomId = {
  ...roomId,
  nullable: true
};
